import { render, staticRenderFns } from "./StaffingNeeds.vue?vue&type=template&id=72a07afa&scoped=true&"
import script from "./StaffingNeeds.vue?vue&type=script&lang=js&"
export * from "./StaffingNeeds.vue?vue&type=script&lang=js&"
import style0 from "./StaffingNeeds.vue?vue&type=style&index=0&id=72a07afa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a07afa",
  null
  
)

export default component.exports